module.exports = __webpack_public_path__ + "img/sz.48df7b98.svg";